/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout';
var clazzRouter = [
  // {
  //   path: '/school/file',
  //   component: Layout,
  //   meta: { roles: ['schoolclazz'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'file',
  //       component: () => import('@/views/school/file'),
  //       meta: { title: '学生档案管理', icon: 'ope' },
  //     }
  //   ]
  // },

  // {
  //   path: '/school/roport/class',
  //   name: 'roport',
  //   component: Layout,
  //   meta: { title: '数据分析', icon: 'nav_data', roles: ['schoolclazz'] },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/school/report/class'),
  //       meta: { title: '班级数据分析' }
  //     }
  //   ]
  // },
  // {
  //   path: '/school/personal',
  //   meta: { roles: ['schoolclazz'] },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'personal',
  //       component: () => import('@/views/gov/personal'),
  //       meta: { title: '个案数据分析', icon: 'people' },
  //     }
  //   ]
  // },
];
export default clazzRouter;